module.exports = (p) => {
  // Represent a point { x, y } in two-element array [x, y]
  //
  // Parameters
  //   p
  //     a point
  //
  // Return
  //   an array [x, y]
  //
  return [p.x, p.y]
}
